import {Component, OnInit} from '@angular/core'

import {ActivatedRoute} from '@angular/router'
import {AngularFirestore} from 'angularfire2/firestore'
import {take} from 'rxjs/operators'
import {BrandService} from 'app/brand/brand.service'
import * as firebase from 'firebase'

const PROJECTCOLLECTION = 'projects'

@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  providers: [BrandService],
  styleUrls: ['./project-edit.component.scss'],
})
export class ProjectEditComponent implements OnInit {
  projectId: string
  project: any

  constructor(
    private firestore: AngularFirestore,
    public route: ActivatedRoute,
    public brandService: BrandService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(({projectId, clientId}) => {
      this.projectId = projectId
      this.firestore
        .doc([PROJECTCOLLECTION, projectId].join('/'))
        .valueChanges()
        .pipe(take(1))
        .subscribe(project => {
          this.project = project || {}
          this.project.id = projectId
          this.project.client = this.project.client || clientId
          this.project.date =
            this.project.date || firebase.firestore.FieldValue.serverTimestamp()
        })
    })
  }

  save() {
    this.firestore
      .doc([PROJECTCOLLECTION, this.projectId].join('/'))
      .ref.set(this.project, {merge: true})
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-edit/project-edit.component.ts